import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SafeHTMLPipe } from './safeHtml.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [SafeHTMLPipe],
    providers: [SafeHTMLPipe],
    exports: [SafeHTMLPipe],
})
export class SafeHTMLPipeModule {}
